import { rootApi } from "../../api/rootApi";

export const schemeApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchTierData: builder.mutation({
            query: (params) => {
                return {
                    method: "GET",
                    url: `/tenant/scheme-tier?${new URLSearchParams({
                        scheme_id: params?.scheme_id,
                        with_scheme: false,
                    }).toString()}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                };
            },
        }),

        createTierData: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/scheme-tier/create`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params?.body,
                };
            },
        }),

        updateTierData: builder.mutation({
            query: (params) => {
                return {
                    method: "PUT",
                    url: `/tenant/scheme-tier/update?${new URLSearchParams({
                        id: params?.id,
                    }).toString()}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params?.body,
                };
            },
        }),

        deleteTierData: builder.mutation({
            query: (params) => {
                return {
                    method: "DELETE",
                    url: `/tenant/scheme-tier/delete?${new URLSearchParams({
                        id: params?.id,
                        scheme_id: params?.scheme_id,
                    }).toString()}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                };
            },
        }),
    }),
});

export const {
    useFetchTierDataMutation,
    useCreateTierDataMutation,
    useUpdateTierDataMutation,
    useDeleteTierDataMutation,
} = schemeApi;
